export enum EventTypeIds {
  "PrimaryShow" = 1,
  "SecondaryShow",
  "Event",
}

export type EventTypeDescriptions = "Primary Show" | "Secondary Show" | "Event";
